<vdms-hq-ui-dialog-wrapper size="wide">
  <h1 title>{{ 'pages.fields.tree_dialog.title' | translate }}</h1>

  <div class="dialog-content" content>
    @if (tree(); as root) {
      <ul class="tree-list">
        <ng-container
          [ngTemplateOutlet]="treeNode"
          [ngTemplateOutletContext]="{
            $implicit: root,
            level: 0,
          }"
        />
      </ul>
    } @else {
      <vdms-hq-ui-info-bar
        [type]="InfoBarType.INFO"
        [message]="'pages.fields.tree_dialog.empty' | translate"
        icon="info"
      />
    }
  </div>

  <ng-container footer>
    <vdms-hq-ui-button (click)="close()" color="secondary">{{ 'common.global.close' | translate }}</vdms-hq-ui-button>
  </ng-container>
</vdms-hq-ui-dialog-wrapper>

<ng-template #treeNode let-node let-level="level">
  <li class="tree-node">
    <article class="tree-card" [style.margin-inline-start.px]="level * 20">
      <header class="tree-card__value-block">
        <div class="tree-card__type-content">
          <span class="tree-card__type">{{ node.typeName }}</span>

          @if (node.isFocus) {
            <span class="chip chip--focus">{{ 'pages.fields.tree_dialog.focus' | translate }}</span>
          }
          @if (node.isInParentPath) {
            <span class="chip chip--path">{{ 'pages.fields.tree_dialog.parent_path' | translate }}</span>
          }
          @if (node.isRelatedViaSibling) {
            <span class="chip chip--related">{{ 'pages.fields.tree_dialog.sibling_related' | translate }}</span>
          }
        </div>
        @if (node.children.length > 0) {
          <vdms-hq-ui-button
            class="tree-card__toggle"
            color="transparent"
            [icon]="isNodeCollapsed(node.uuid) ? 'expand_more' : 'expand_less'"
            [iconOnly]="true"
            size="small"
            (click)="toggleNode(node.uuid)"
          />
        }
      </header>
      <span class="tree-card__value">{{ node.label }}</span>

      <div class="tree-card__chips">
        @if (node.restricted.length > 0) {
          <span class="chip__separator">{{ 'pages.fields.tree_dialog.restricted_to' | translate }}</span>

          @for (restriction of node.restricted; track restriction) {
            <span class="chip chip--restricted">{{ restriction }}</span>
          }
        }

        @if (node.siblings.length > 0) {
          <span class="chip__separator">{{ 'pages.fields.tree_dialog.siblings' | translate }}</span>

          @for (sibling of node.siblings; track sibling.key + sibling.value) {
            <span class="chip chip--meta">
              <span class="chip__meta">{{ sibling.key }}:</span>
              <span class="chip__value">{{ sibling.value }}</span>
            </span>
          }
        }
      </div>
    </article>

    @if (node.children.length > 0 && !isNodeCollapsed(node.uuid)) {
      <ul class="tree-list">
        @for (child of node.children; track child.uuid) {
          <ng-container
            [ngTemplateOutlet]="treeNode"
            [ngTemplateOutletContext]="{
              $implicit: child,
              level: level + 1,
            }"
          />
        }
      </ul>
    }
  </li>
</ng-template>
